module.exports = __webpack_public_path__ + "img/youtube.c4be3aa7.svg";